export default __webpack_public_path__ + "static/media/algo.2f18a3f1.svg";